import { Box, BoxProps } from '@modusign/design-system';

interface PDFDocumentContentLayoutProps extends BoxProps<'div'> {}

const PDFDocumentContentLayout = (props: PDFDocumentContentLayoutProps) => {
  return <Box {...props} flex="1" height="100%" minHeight="0" width="100%" />;
};

export default PDFDocumentContentLayout;
